import { HttpClient } from '@/components/shared/http-client'


export class TabExistsError extends Error {
  constructor(message) {
    super(message)
    this.name = 'TabExistsError'
  }
}

function generateApiUrl(accountCode) {
  return `/api/accounts/${accountCode}/schedules/tabs`
}
function buildParams(tabId) {
  const params = {}
  if (tabId) {
    params['tabId'] = tabId
  }
  return params
}

export async function getScheduleTabs(accountCode) {
  if (!accountCode) return []
  const response = await HttpClient.get(generateApiUrl(accountCode))
  if (response.status !== 200) {
    throw new Error(`HTTP error! Status: ${response.status}`)
  }
  return await response.data
}

export async function renameScheduleTab(accountCode, tab, newName) {
  const url = `/api/accounts/${accountCode}/schedules/tabs/${tab.scheduleTabId}`
  try {
    tab.tabName = newName
    const response = await HttpClient.put(url, tab)
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    return response.data
  } catch (error) {
    console.error(error)
    if (error.response?.status === 409) {
      throw new TabExistsError("A tab with that name exists already")
    }
    throw new Error("Failed to rename schedule tab")
  }
}

export async function deleteScheduleTab(accountCode, scheduleTabId, scheduleType) {
  const url = `/api/accounts/${accountCode}/schedules/tabs/${scheduleTabId}?scheduleType=${scheduleType}`
  try {
    await HttpClient.delete(url)
  } catch (error) {
    console.error(error)
    throw new Error("Failed to delete schedule tab")
  }
}

export async function downloadTabAsSingleTabExcel(accountCode, type, tabId) {
  const url = `/api/accounts/${accountCode}/schedules/export/${type}/excel`
  const params = buildParams(tabId)
  try {
    const response = await HttpClient.get(url, { params, responseType: 'blob' })
    return response.data
  } catch (err) {
    console.error(err)
    throw err
  }
}

export async function postNewScheduleTab(accountCode, scheduleType, newTabName) {
  const request = {
    scheduleType: scheduleType,
    tabName: newTabName
  }
  try {
    const response = await HttpClient.post(generateApiUrl(accountCode), request)
    if (response.status !== 201) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    return response.data
  } catch (error) {
    console.error(error)
    if (error.response?.status === 409) {
      throw new TabExistsError("A tab with that name exists already")
    }
    throw new Error("Failed to create new schedule tab")
  }
}
